import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Übersicht',
      href: '/de/Innenkameras/IN-8003_HD/',
    },
    {
      text: 'Specifications',
      href: '/de/Innenkameras/IN-8003_HD/Technische_Spezifikationen/',
    },
    {
      text: 'Features',
      href: '/de/Innenkameras/IN-8003_HD/Produkt_Features/',
    },
    {
      text: 'Installation',
      href: '/de/Innenkameras/IN-8003_HD/Schnell_Installation/',
    },
    {
      text: 'Objektivjustage',
      href: '/de/Innenkameras/IN-8003_HD/Objektivjustage/',
    },
    {
      text: 'Handbuch',
      href: '/de/Innenkameras/IN-8003_HD/Handbuch/',
    },
    {
      text: '◄ Innenkameras',
      href: '/de/Innenkameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-8003 Full HD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}

// export default () => {
//   const breadcrumbs = [
//     {
//       text: 'Overview',
//       href: '/Innenkameras/IN-8003_HD/',
//     },
//     {
//       text: 'Technical Specifications',
//       href: '/Innenkameras/IN-8003_HD/Technical_Specifications/',
//     },
//     {
//       text: 'Product Features',
//       href: '/Innenkameras/IN-8003_HD/Product_Features/',
//     },
//     {
//       text: 'Installation',
//       href: '/Innenkameras/IN-8003_HD/Quick_Installation/',
//     },
//     {
//       text: 'Lense Adjustment',
//       href: '/Innenkameras/IN-8003_HD/Lense_Adjustment/',
//     },
//     {
//       text: '◄ Usermanual',
//       href: '/Innenkameras/IN-8003_HD/Usermanual/',
//     }
//   ];

//   return (
//     <Fragment>
//       <EuiBreadcrumbs
//         truncate={true}
//         breadcrumbs={breadcrumbs}
//         max={6}
//         aria-label="INSTAR IN-8003 Full HD Online Usermanual Chapters"
//       />
//       <EuiSpacer />
//     </Fragment>
//   );
// }